import { Injectable } from '@angular/core'

@Injectable({
  providedIn: 'root',
})
export class UserSecurityProfileService {
  sbf: any
  plan: any
  rawData: any
  userDefaultClientPlan: any
  userProfileData: any = {}
  allPreferredPlans: any
  allInternalPlans: any
  clientAuthorizedPlans: any[] = []
  esetupFlagArr :any[] = [];
  setUserProfileData = (data: any) => {
    this.rawData = data
    if (data) {
      this.rawData = data
      this.userProfileData = {
        rawData: data,

        isExternal: data.isExternalUser,

        isInternal: !data.isExternalUser,

        isAccessExpired: data.isAccessExpired,
      }
    }
  }

  getUserProfileData = () => {
    return this.userProfileData
  }
  hasPlanPermission = (businessFunction: any, userSelectedPlans: any[]) => {
    let returnValue
    returnValue = false
    if (this.rawData) {
      if (!this.rawData.isExternalUser === true) {
        returnValue = this.hasUserPermission(businessFunction)
      } else {
        returnValue = this.getPlanPermissionsForSelectedPlansExternal(
          businessFunction,
          userSelectedPlans,
          this.rawData.planAccess,
        )
      }
    }

    return returnValue
  }
  //the function retrun true/false based on user persmission check
  hasUserPermission = (businessFunction: any) => {
    if (this.rawData) {
      return (
        this.rawData.authorities !== null &&
        this.rawData.authorities.authority.indexOf(businessFunction) >= 0
      )
    }
    return false
  }

  // This function returns true if the provided SBF, given the list of plans the user has currently selected in the Population selector.
  // It loops through the user's AEMS  plan permission list.
  // Note: for external only.
  getPlanPermissionsForSelectedPlansExternal = (
    businessFunction: any,
    userSelectedPlans: any[],
    planAccess: any,
  ) => {
    let returnValue = false
    if (planAccess !== null && userSelectedPlans.length > 0) {
      for (const plan of userSelectedPlans) {
        if (
          this.getPlanPermissionForSinglePlan(
            businessFunction,
            plan,
            planAccess,
          )
        ) {
          returnValue = true
          break
        }
      }
    }
    return returnValue
  }
  // This function returns true if the provided SBF is in the provided plan.
  // It loops through the user's AEMS  plan permission list.
  // Note: for external only.
  getPlanPermissionForSinglePlan = (
    businessFunction: any,
    plan: any,
    planAccess: any,
  ) => {
    let returnValue = false
    if (planAccess !== null) {
      for (const i in planAccess) {
        if (planAccess[i].planId === plan) {
          // tslint:disable-next-line:max-line-length
          returnValue =
            planAccess[i].planAuthorities !== null &&
            planAccess[i].planAuthorities.planAuthority.indexOf(
              businessFunction,
            ) >= 0
          break
        }
      }
    }
    return returnValue
  }
  //set Newport User flag in service
  getNewportUserFlag = () => {
    let returnNewPortValue = false
    if (
      this.hasUserPermission('SVC_CHANGE_PROFILE_TYPE_ELIGIBILITY_NSU') ||
      this.hasUserPermission('SVC_CHANGE_PROFILE_TYPE_ELIGIBILITY_NSA')
    ) {
      returnNewPortValue = true
    }
    return returnNewPortValue
  }
  setUserDefaultClientAndPlan = (data: any) => {
    this.userDefaultClientPlan = data
  }
  getUserDefaultClientAndPlan = () => {
    return this.userDefaultClientPlan
  }
  setAllPreferredPlans = (data: any) => {
    this.allPreferredPlans = data
  }
  getAllPreferredPlans = () => {
    return this.allPreferredPlans
  }
  setAllInternalPlans = (data: any) => {
    this.allInternalPlans = data
  }
  getAllInternalPlans = () => {
    return this.allInternalPlans
  }
  setClientAuthorizedPlans = (data: any) => {
    this.clientAuthorizedPlans = data
  }
  getClientAuthorizedPlans = () => {
    return this.clientAuthorizedPlans
  }
  setEsetUpFlag(key:string,value:boolean){
    switch(key){
        case 'AutoIncPer':
          this.esetupFlagArr['AutoIncPer'] = value;
          break;
        case 'TotalRateOfReturnPer':
          this.esetupFlagArr['TotalRateOfReturnPer'] = value;
          break;
        case 'TotalRateOfReturnPerDisplayFlag':
            this.esetupFlagArr['TotalRateOfReturnPerDisplayFlag'] = value;
            break;
        case 'EquityAllocationPer':
          this.esetupFlagArr['EquityAllocationPer'] = value;
          break;
        case 'EquityAllocationPerDisplayFlag':
          this.esetupFlagArr['EquityAllocationPerDisplayFlag'] = value;
          break;
        case 'ParRate':
          this.esetupFlagArr['ParRate'] = value;
          break;
        case 'AccountBalance':
          this.esetupFlagArr['AccountBalance'] = value;
          break;
        case 'Electivedeferrals':
          this.esetupFlagArr['Electivedeferrals'] = value;
          break;
        case 'ProfManagAlloc':
            this.esetupFlagArr['ProfManagAlloc'] = value;
          break;

    }
    return this.esetupFlagArr;
  }
  getEsetUpFlag(){
    return this.esetupFlagArr;
  }
}
